// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteV1BusinessPartnerCurrentIconData, DeleteV1BusinessPartnerCurrentIconErrors, DeleteV1BusinessPartnerCurrentIconResponses, DeleteV1DomainByIdData, DeleteV1DomainByIdErrors, DeleteV1DomainByIdResponses, DeleteV1IdentityCurrentInviteToJoinByIdData, DeleteV1IdentityCurrentInviteToJoinByIdErrors, DeleteV1IdentityCurrentInviteToJoinByIdResponses, DeleteV1IdentityCurrentRequestToJoinByIdData, DeleteV1IdentityCurrentRequestToJoinByIdErrors, DeleteV1IdentityCurrentRequestToJoinByIdResponses, DeleteV1IdentityCurrentUserByIdData, DeleteV1IdentityCurrentUserByIdErrors, DeleteV1IdentityCurrentUserByIdResponses, DeleteV1IdentityProviderByIdData, DeleteV1IdentityProviderByIdErrors, DeleteV1IdentityProviderByIdResponses, DeleteV1InviteToJoinByIdData, DeleteV1InviteToJoinByIdErrors, DeleteV1InviteToJoinByIdResponses, DeleteV1OauthClientByIdData, DeleteV1OauthClientByIdErrors, DeleteV1OauthClientByIdResponses, DeleteV1RequestToJoinByIdData, DeleteV1RequestToJoinByIdErrors, DeleteV1RequestToJoinByIdResponses, DeleteV1UserByIdData, DeleteV1UserByIdErrors, DeleteV1UserByIdResponses, GetV1BusinessPartnerCurrentData, GetV1BusinessPartnerCurrentDivisionsData, GetV1BusinessPartnerCurrentDivisionsErrors, GetV1BusinessPartnerCurrentDivisionsResponses, GetV1BusinessPartnerCurrentErrors, GetV1BusinessPartnerCurrentProfilesData, GetV1BusinessPartnerCurrentProfilesErrors, GetV1BusinessPartnerCurrentProfilesResponses, GetV1BusinessPartnerCurrentResponses, GetV1BusinessPartnerCurrentSuggestIdentitiesData, GetV1BusinessPartnerCurrentSuggestIdentitiesErrors, GetV1BusinessPartnerCurrentSuggestIdentitiesResponses, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoData, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoErrors, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponses, GetV1ContextData, GetV1ContextErrors, GetV1ContextResponses, GetV1DomainByIdData, GetV1DomainByIdErrors, GetV1DomainByIdResponses, GetV1DomainsData, GetV1DomainsErrors, GetV1DomainsResponses, GetV1IdentitiesData, GetV1IdentitiesErrors, GetV1IdentitiesResponses, GetV1IdentityCurrentBusinessPartnersData, GetV1IdentityCurrentBusinessPartnersErrors, GetV1IdentityCurrentBusinessPartnersResponses, GetV1IdentityCurrentData, GetV1IdentityCurrentErrors, GetV1IdentityCurrentInvitesToJoinData, GetV1IdentityCurrentInvitesToJoinErrors, GetV1IdentityCurrentInvitesToJoinResponses, GetV1IdentityCurrentRequestsToJoinData, GetV1IdentityCurrentRequestsToJoinErrors, GetV1IdentityCurrentRequestsToJoinResponses, GetV1IdentityCurrentRequestToJoinByIdData, GetV1IdentityCurrentRequestToJoinByIdErrors, GetV1IdentityCurrentRequestToJoinByIdResponses, GetV1IdentityCurrentResponses, GetV1IdentityCurrentUsersData, GetV1IdentityCurrentUsersErrors, GetV1IdentityCurrentUsersResponses, GetV1IdentityProviderByIdData, GetV1IdentityProviderByIdErrors, GetV1IdentityProviderByIdResponses, GetV1IdentityProvidersData, GetV1IdentityProvidersErrors, GetV1IdentityProvidersResponses, GetV1InvitesToJoinData, GetV1InvitesToJoinErrors, GetV1InvitesToJoinResponses, GetV1InviteToJoinByIdData, GetV1InviteToJoinByIdErrors, GetV1InviteToJoinByIdResponses, GetV1OauthClientByIdData, GetV1OauthClientByIdErrors, GetV1OauthClientByIdResponses, GetV1OauthClientsCategoriesData, GetV1OauthClientsCategoriesErrors, GetV1OauthClientsCategoriesResponses, GetV1OauthClientsData, GetV1OauthClientsErrors, GetV1OauthClientsResponses, GetV1RequestsToJoinData, GetV1RequestsToJoinErrors, GetV1RequestsToJoinResponses, GetV1RequestToJoinByIdData, GetV1RequestToJoinByIdErrors, GetV1RequestToJoinByIdResponses, GetV1RolesCurrentData, GetV1RolesCurrentErrors, GetV1RolesCurrentResponses, GetV1UserByIdData, GetV1UserByIdErrors, GetV1UserByIdResponses, GetV1UserCurrentAppsData, GetV1UserCurrentAppsErrors, GetV1UserCurrentAppsResponses, GetV1UserCurrentData, GetV1UserCurrentErrors, GetV1UserCurrentOauthClientsData, GetV1UserCurrentOauthClientsErrors, GetV1UserCurrentOauthClientsResponses, GetV1UserCurrentResponses, GetV1UsersData, GetV1UsersErrors, GetV1UsersResponses, PostV1BusinessPartnerCurrentIconData, PostV1BusinessPartnerCurrentIconErrors, PostV1BusinessPartnerCurrentIconResponses, PostV1DomainData, PostV1DomainErrors, PostV1DomainResponses, PostV1IdentityCurrentInviteToJoinByIdAcceptData, PostV1IdentityCurrentInviteToJoinByIdAcceptErrors, PostV1IdentityCurrentInviteToJoinByIdAcceptResponses, PostV1IdentityProviderData, PostV1IdentityProviderErrors, PostV1IdentityProviderResponses, PostV1InviteToJoinData, PostV1InviteToJoinErrors, PostV1InviteToJoinResponses, PostV1OauthClientByIdIconData, PostV1OauthClientByIdIconErrors, PostV1OauthClientByIdIconResponses, PostV1OauthClientData, PostV1OauthClientErrors, PostV1OauthClientResponses, PostV1RequestToJoinData, PostV1RequestToJoinErrors, PostV1RequestToJoinResponses, PostV1SupportTokenData, PostV1SupportTokenErrors, PostV1SupportTokenResponses, PostV1UserData, PostV1UserErrors, PostV1UserResponses, PutV1BusinessPartnerCurrentData, PutV1BusinessPartnerCurrentErrors, PutV1BusinessPartnerCurrentResponses, PutV1DomainByIdData, PutV1DomainByIdErrors, PutV1DomainByIdResponses, PutV1DomainByIdVerifyData, PutV1DomainByIdVerifyErrors, PutV1DomainByIdVerifyResponses, PutV1IdentityCurrentData, PutV1IdentityCurrentErrors, PutV1IdentityCurrentResponses, PutV1IdentityProviderByIdData, PutV1IdentityProviderByIdErrors, PutV1IdentityProviderByIdResponses, PutV1InviteToJoinByIdData, PutV1InviteToJoinByIdErrors, PutV1InviteToJoinByIdResponses, PutV1OauthClientByIdData, PutV1OauthClientByIdErrors, PutV1OauthClientByIdResponses, PutV1UserByIdData, PutV1UserByIdErrors, PutV1UserByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get the current BusinessPartner
 *
 *  Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile". Include icon param to get extra information about icon.
 */
export const getV1BusinessPartnerCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentResponses, GetV1BusinessPartnerCurrentErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentResponses, GetV1BusinessPartnerCurrentErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current',
    ...options
});

/**
 * Update the current BusinessPartner
 *
 *  Update the current BusinessPartner. Must have `bp_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1BusinessPartnerCurrent = <ThrowOnError extends boolean = false>(options: Options<PutV1BusinessPartnerCurrentData, ThrowOnError>): RequestResult<PutV1BusinessPartnerCurrentResponses, PutV1BusinessPartnerCurrentErrors, ThrowOnError> => (options.client ?? client).put<PutV1BusinessPartnerCurrentResponses, PutV1BusinessPartnerCurrentErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the divisions of the current BusinessPartner organization
 *
 *  Get the divisions of the current BusinessPartner for the current Identity, with hydrated information.  BusinessPartners which are inviteOnly are omitted from the response depending on the current User profile. Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentDivisions = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentDivisionsData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentDivisionsResponses, GetV1BusinessPartnerCurrentDivisionsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentDivisionsResponses, GetV1BusinessPartnerCurrentDivisionsErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current/divisions',
    ...options
});

/**
 * Delete the icon for the current business partner
 *
 *  Requires scope "topcon.ciam.pap".
 */
export const deleteV1BusinessPartnerCurrentIcon = <ThrowOnError extends boolean = false>(options?: Options<DeleteV1BusinessPartnerCurrentIconData, ThrowOnError>): RequestResult<DeleteV1BusinessPartnerCurrentIconResponses, DeleteV1BusinessPartnerCurrentIconErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteV1BusinessPartnerCurrentIconResponses, DeleteV1BusinessPartnerCurrentIconErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current/icon',
    ...options
});

/**
 * Upload an icon for the current business partner
 *
 *  Post an icon for the current BusinessPartner. Must have `bp_admin` role. Post a form with `thumbnail` png or jpeg, which will be resized to 256x256 Requires scope "topcon.ciam.pap".
 */
export const postV1BusinessPartnerCurrentIcon = <ThrowOnError extends boolean = false>(options: Options<PostV1BusinessPartnerCurrentIconData, ThrowOnError>): RequestResult<PostV1BusinessPartnerCurrentIconResponses, PostV1BusinessPartnerCurrentIconErrors, ThrowOnError> => (options.client ?? client).post<PostV1BusinessPartnerCurrentIconResponses, PostV1BusinessPartnerCurrentIconErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current/icon',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get the available profiles for the current BusinessPartner
 *
 *  Get the profiles which are available to assign Users for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentProfiles = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentProfilesData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentProfilesResponses, GetV1BusinessPartnerCurrentProfilesErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentProfilesResponses, GetV1BusinessPartnerCurrentProfilesErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current/profiles',
    ...options
});

/**
 * Get a list of Identity which might be added to the BusinessPartner as a User
 *
 *  Suggest a list of identities whose email address domains match a registered domain of the current BusinessPartner, and are not already a User or RequestToJoin. `suggest` parameter if present must be at least 3 characters. `suggest` parameter is case insensitive contains for the username part of the email. Result set will be limited to 64 records. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentSuggestIdentities = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentSuggestIdentitiesData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentSuggestIdentitiesResponses, GetV1BusinessPartnerCurrentSuggestIdentitiesErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentSuggestIdentitiesResponses, GetV1BusinessPartnerCurrentSuggestIdentitiesErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current/suggestIdentities',
    ...options
});

/**
 * Get the current BusinessPartner
 *
 *  Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentWithCurrentIdentityInfo = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentWithCurrentIdentityInfoData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponses, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponses, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/businessPartner/current/withCurrentIdentityInfo',
    ...options
});

/**
 * Get the session context (based on the token)
 *
 *  Get information about the current session context. If the current session is a service provider (dealer) supporting a customer, the body will have a 'serviceProvider' object. If the current session is topcon supporting a dealer or customer, the body will have a 'topconSupport' object. Otherwise the body may have 'identity' and 'businessPartner' objects detailing the current identity and businessPartner respectively. The identity may be the owner or user of the businessPartner if it is not a support session. See result body schema for more information. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1Context = <ThrowOnError extends boolean = false>(options?: Options<GetV1ContextData, ThrowOnError>): RequestResult<GetV1ContextResponses, GetV1ContextErrors, ThrowOnError> => (options?.client ?? client).get<GetV1ContextResponses, GetV1ContextErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/context',
    ...options
});

/**
 * Create a Domain
 *
 *  Create a Domain for a BusinessPartner.  The Domain will require validation using DNS TXT record before if can be used. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1Domain = <ThrowOnError extends boolean = false>(options: Options<PostV1DomainData, ThrowOnError>): RequestResult<PostV1DomainResponses, PostV1DomainErrors, ThrowOnError> => (options.client ?? client).post<PostV1DomainResponses, PostV1DomainErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/domain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a particular Domain
 *
 *  Delete a particular Domain. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1DomainById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1DomainByIdData, ThrowOnError>): RequestResult<DeleteV1DomainByIdResponses, DeleteV1DomainByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1DomainByIdResponses, DeleteV1DomainByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/domain/{id}',
    ...options
});

/**
 * Get a particular Domain
 *
 *  Get a particular Domain. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1DomainById = <ThrowOnError extends boolean = false>(options: Options<GetV1DomainByIdData, ThrowOnError>): RequestResult<GetV1DomainByIdResponses, GetV1DomainByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1DomainByIdResponses, GetV1DomainByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/domain/{id}',
    ...options
});

/**
 * Update a particular Domain
 *
 *  Update a particular Domain. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1DomainById = <ThrowOnError extends boolean = false>(options: Options<PutV1DomainByIdData, ThrowOnError>): RequestResult<PutV1DomainByIdResponses, PutV1DomainByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1DomainByIdResponses, PutV1DomainByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/domain/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify the DNS TXT record for a Domain
 *
 *  Perform verification of the DNS TXT record and update the Domain verified status accordingly. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1DomainByIdVerify = <ThrowOnError extends boolean = false>(options: Options<PutV1DomainByIdVerifyData, ThrowOnError>): RequestResult<PutV1DomainByIdVerifyResponses, PutV1DomainByIdVerifyErrors, ThrowOnError> => (options.client ?? client).put<PutV1DomainByIdVerifyResponses, PutV1DomainByIdVerifyErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/domain/{id}/verify',
    ...options
});

/**
 * Get the list of Domain for the current BusinessPartner (based on the token)
 *
 *  Get the list of Domain for the current BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1Domains = <ThrowOnError extends boolean = false>(options?: Options<GetV1DomainsData, ThrowOnError>): RequestResult<GetV1DomainsResponses, GetV1DomainsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1DomainsResponses, GetV1DomainsErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/domains',
    ...options
});

/**
 * Search identities
 *
 *  Search for identities. <hr /> <br /> <br /> Supports filtering by email and name (searches across first and last name). Requires profile "topcon.customer_service.support". Requires scope "topcon.ciam.pap".
 */
export const getV1Identities = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentitiesData, ThrowOnError>): RequestResult<GetV1IdentitiesResponses, GetV1IdentitiesErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentitiesResponses, GetV1IdentitiesErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identities',
    ...options
});

/**
 * Get the current Identity
 *
 *  Get the current Identity.  Set external param=true to get externalIdentities. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1IdentityCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityCurrentData, ThrowOnError>): RequestResult<GetV1IdentityCurrentResponses, GetV1IdentityCurrentErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityCurrentResponses, GetV1IdentityCurrentErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current',
    ...options
});

/**
 * Put the current Identity
 *
 *  Put the current Identity. Set archived true will soft delete the identity, after one week it will be deleted. Logging back in will unarchive the identity and prevent the delete. If the identity owns business partners then 409. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const putV1IdentityCurrent = <ThrowOnError extends boolean = false>(options: Options<PutV1IdentityCurrentData, ThrowOnError>): RequestResult<PutV1IdentityCurrentResponses, PutV1IdentityCurrentErrors, ThrowOnError> => (options.client ?? client).put<PutV1IdentityCurrentResponses, PutV1IdentityCurrentErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the BusinessPartner related to the current Identity
 *
 *  Get the business partners related in some way to the current Identity, with hydrated information. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentBusinessPartners = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityCurrentBusinessPartnersData, ThrowOnError>): RequestResult<GetV1IdentityCurrentBusinessPartnersResponses, GetV1IdentityCurrentBusinessPartnersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityCurrentBusinessPartnersResponses, GetV1IdentityCurrentBusinessPartnersErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/businessPartners',
    ...options
});

/**
 * Reject an InviteToJoin
 *
 *  Reject an InviteToJoin.  The current identity must have an email matching the email of the InviteToJoin.  Success will delete the InviteToJoin object. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityCurrentInviteToJoinById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1IdentityCurrentInviteToJoinByIdData, ThrowOnError>): RequestResult<DeleteV1IdentityCurrentInviteToJoinByIdResponses, DeleteV1IdentityCurrentInviteToJoinByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1IdentityCurrentInviteToJoinByIdResponses, DeleteV1IdentityCurrentInviteToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/inviteToJoin/{id}',
    ...options
});

/**
 * Accept an InviteToJoin
 *
 *  Accept an InviteToJoin.  The current identity must have an email matching the email of the InviteToJoin. Success will delete the InviteToJoin object. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const postV1IdentityCurrentInviteToJoinByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostV1IdentityCurrentInviteToJoinByIdAcceptData, ThrowOnError>): RequestResult<PostV1IdentityCurrentInviteToJoinByIdAcceptResponses, PostV1IdentityCurrentInviteToJoinByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostV1IdentityCurrentInviteToJoinByIdAcceptResponses, PostV1IdentityCurrentInviteToJoinByIdAcceptErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/inviteToJoin/{id}/accept',
    ...options
});

/**
 * Get the list of InviteToJoin for the current Identity (based on the token)
 *
 *  Get the InviteToJoin and hydrated BusinessPartner information for Invitations related to the current Identity. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentInvitesToJoin = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityCurrentInvitesToJoinData, ThrowOnError>): RequestResult<GetV1IdentityCurrentInvitesToJoinResponses, GetV1IdentityCurrentInvitesToJoinErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityCurrentInvitesToJoinResponses, GetV1IdentityCurrentInvitesToJoinErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/invitesToJoin',
    ...options
});

/**
 * Withdraw a RequestToJoin
 *
 *  Withdraw a RequestToJoin.  Success will delete the RequestToJoin object. Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityCurrentRequestToJoinById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1IdentityCurrentRequestToJoinByIdData, ThrowOnError>): RequestResult<DeleteV1IdentityCurrentRequestToJoinByIdResponses, DeleteV1IdentityCurrentRequestToJoinByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1IdentityCurrentRequestToJoinByIdResponses, DeleteV1IdentityCurrentRequestToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/requestToJoin/{id}',
    ...options
});

/**
 * Get a particular RequestToJoin for the current Identity
 *
 *  Get a particular RequestToJoin for the current Identity. Includes reviewers who can approve or reject the request. Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentRequestToJoinById = <ThrowOnError extends boolean = false>(options: Options<GetV1IdentityCurrentRequestToJoinByIdData, ThrowOnError>): RequestResult<GetV1IdentityCurrentRequestToJoinByIdResponses, GetV1IdentityCurrentRequestToJoinByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1IdentityCurrentRequestToJoinByIdResponses, GetV1IdentityCurrentRequestToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/requestToJoin/{id}',
    ...options
});

/**
 * Get the list of RequestToJoin for the current Identity (based on the token)
 *
 *  Get the list of RequestToJoin for the current Identity. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentRequestsToJoin = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityCurrentRequestsToJoinData, ThrowOnError>): RequestResult<GetV1IdentityCurrentRequestsToJoinResponses, GetV1IdentityCurrentRequestsToJoinErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityCurrentRequestsToJoinResponses, GetV1IdentityCurrentRequestsToJoinErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/requestsToJoin',
    ...options
});

/**
 * Leave an organization
 *
 *  Leave an organization by deleting the User record linking the current Identity to a BusinessPartner. Cannot leave if you are the owner of the BusinessPartner - transfer ownership first. If using a BP-scoped token, cannot leave the current BusinessPartner (use identity-only token for that). Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityCurrentUserById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1IdentityCurrentUserByIdData, ThrowOnError>): RequestResult<DeleteV1IdentityCurrentUserByIdResponses, DeleteV1IdentityCurrentUserByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1IdentityCurrentUserByIdResponses, DeleteV1IdentityCurrentUserByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/user/{id}',
    ...options
});

/**
 * Get the list of User for the current Identity (based on the token)
 *
 *  Get the User and hydrated BusinessPartner information for User related to the current Identity. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentUsers = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityCurrentUsersData, ThrowOnError>): RequestResult<GetV1IdentityCurrentUsersResponses, GetV1IdentityCurrentUsersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityCurrentUsersResponses, GetV1IdentityCurrentUsersErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identity/current/users',
    ...options
});

/**
 * Create an IdentityProvider
 *
 *  Create an IdentityProvider for a BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1IdentityProvider = <ThrowOnError extends boolean = false>(options: Options<PostV1IdentityProviderData, ThrowOnError>): RequestResult<PostV1IdentityProviderResponses, PostV1IdentityProviderErrors, ThrowOnError> => (options.client ?? client).post<PostV1IdentityProviderResponses, PostV1IdentityProviderErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identityProvider',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a particular IdentityProvider
 *
 *  Delete a particular IdentityProvider. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityProviderById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1IdentityProviderByIdData, ThrowOnError>): RequestResult<DeleteV1IdentityProviderByIdResponses, DeleteV1IdentityProviderByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1IdentityProviderByIdResponses, DeleteV1IdentityProviderByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identityProvider/{id}',
    ...options
});

/**
 * Get a particular IdentityProvider
 *
 *  Get a particular IdentityProvider. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityProviderById = <ThrowOnError extends boolean = false>(options: Options<GetV1IdentityProviderByIdData, ThrowOnError>): RequestResult<GetV1IdentityProviderByIdResponses, GetV1IdentityProviderByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1IdentityProviderByIdResponses, GetV1IdentityProviderByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identityProvider/{id}',
    ...options
});

/**
 * Update a particular IdentityProvider
 *
 *  Update a particular IdentityProvider. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1IdentityProviderById = <ThrowOnError extends boolean = false>(options: Options<PutV1IdentityProviderByIdData, ThrowOnError>): RequestResult<PutV1IdentityProviderByIdResponses, PutV1IdentityProviderByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1IdentityProviderByIdResponses, PutV1IdentityProviderByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identityProvider/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of IdentityProvider for the current BusinessPartner (based on the token)
 *
 *  Get the list of IdentityProvider for the current BusinessPartner. Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityProviders = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityProvidersData, ThrowOnError>): RequestResult<GetV1IdentityProvidersResponses, GetV1IdentityProvidersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityProvidersResponses, GetV1IdentityProvidersErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/identityProviders',
    ...options
});

/**
 * Create an InviteToJoin for the current BusinessPartner (based on the token)
 *
 *  Create an InviteToJoin.  This sends an email to the invited identity with a link to login or register an identity to accept. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1InviteToJoin = <ThrowOnError extends boolean = false>(options: Options<PostV1InviteToJoinData, ThrowOnError>): RequestResult<PostV1InviteToJoinResponses, PostV1InviteToJoinErrors, ThrowOnError> => (options.client ?? client).post<PostV1InviteToJoinResponses, PostV1InviteToJoinErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/inviteToJoin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a particular InviteToJoin
 *
 *  Delete a particular InviteToJoin.  InviteToJoin entities are also deleted when they are accepted by the Identity to which the invite was extended. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1InviteToJoinById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1InviteToJoinByIdData, ThrowOnError>): RequestResult<DeleteV1InviteToJoinByIdResponses, DeleteV1InviteToJoinByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1InviteToJoinByIdResponses, DeleteV1InviteToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/inviteToJoin/{id}',
    ...options
});

/**
 * Get a particular InviteToJoin
 *
 *  Get a particular InviteToJoin. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1InviteToJoinById = <ThrowOnError extends boolean = false>(options: Options<GetV1InviteToJoinByIdData, ThrowOnError>): RequestResult<GetV1InviteToJoinByIdResponses, GetV1InviteToJoinByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1InviteToJoinByIdResponses, GetV1InviteToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/inviteToJoin/{id}',
    ...options
});

/**
 * Update a particular InviteToJoin
 *
 *  Update a particular InviteToJoin.  Updating with the same email address will result in the invitation email being resent to the invited identity. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1InviteToJoinById = <ThrowOnError extends boolean = false>(options: Options<PutV1InviteToJoinByIdData, ThrowOnError>): RequestResult<PutV1InviteToJoinByIdResponses, PutV1InviteToJoinByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1InviteToJoinByIdResponses, PutV1InviteToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/inviteToJoin/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of InviteToJoin for the current BusinessPartner (based on the token)
 *
 *  Get the list of InviteToJoin for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1InvitesToJoin = <ThrowOnError extends boolean = false>(options?: Options<GetV1InvitesToJoinData, ThrowOnError>): RequestResult<GetV1InvitesToJoinResponses, GetV1InvitesToJoinErrors, ThrowOnError> => (options?.client ?? client).get<GetV1InvitesToJoinResponses, GetV1InvitesToJoinErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/invitesToJoin',
    ...options
});

/**
 * Create a Client
 *
 *  Create a Client for a BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1OauthClient = <ThrowOnError extends boolean = false>(options: Options<PostV1OauthClientData, ThrowOnError>): RequestResult<PostV1OauthClientResponses, PostV1OauthClientErrors, ThrowOnError> => (options.client ?? client).post<PostV1OauthClientResponses, PostV1OauthClientErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/oauthClient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a particular Client
 *
 *  Delete a particular OAuth Client. Returns 409 Conflict if the Client is not an OAuth Client. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1OauthClientById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1OauthClientByIdData, ThrowOnError>): RequestResult<DeleteV1OauthClientByIdResponses, DeleteV1OauthClientByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1OauthClientByIdResponses, DeleteV1OauthClientByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/oauthClient/{id}',
    ...options
});

/**
 * Get a particular Client
 *
 *  Get a particular OAuth Client. Returns 409 Conflict if the Client is not an OAuth Client. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1OauthClientById = <ThrowOnError extends boolean = false>(options: Options<GetV1OauthClientByIdData, ThrowOnError>): RequestResult<GetV1OauthClientByIdResponses, GetV1OauthClientByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1OauthClientByIdResponses, GetV1OauthClientByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/oauthClient/{id}',
    ...options
});

/**
 * Update a particular Client
 *
 *  Update a particular OAuth Client. Returns 409 Conflict if the Client is not an OAuth Client. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1OauthClientById = <ThrowOnError extends boolean = false>(options: Options<PutV1OauthClientByIdData, ThrowOnError>): RequestResult<PutV1OauthClientByIdResponses, PutV1OauthClientByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1OauthClientByIdResponses, PutV1OauthClientByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/oauthClient/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload an icon for the stated client
 *
 *  Post an icon for the stated client. Must have `it_admin` role. Post a form with `thumbnail` png or jpeg, which will be resized to 256x256 Requires scope "topcon.ciam.pap".
 */
export const postV1OauthClientByIdIcon = <ThrowOnError extends boolean = false>(options: Options<PostV1OauthClientByIdIconData, ThrowOnError>): RequestResult<PostV1OauthClientByIdIconResponses, PostV1OauthClientByIdIconErrors, ThrowOnError> => (options.client ?? client).post<PostV1OauthClientByIdIconResponses, PostV1OauthClientByIdIconErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/oauthClient/{id}/icon',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get the list of Client for the current BusinessPartner (based on the token)
 *
 *  Get the list of Client for the current BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1OauthClients = <ThrowOnError extends boolean = false>(options?: Options<GetV1OauthClientsData, ThrowOnError>): RequestResult<GetV1OauthClientsResponses, GetV1OauthClientsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1OauthClientsResponses, GetV1OauthClientsErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/oauthClients',
    ...options
});

/**
 * Get the list of allowed app categories
 *
 *  Get the list of allowed app categories for OAuth Clients. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1OauthClientsCategories = <ThrowOnError extends boolean = false>(options?: Options<GetV1OauthClientsCategoriesData, ThrowOnError>): RequestResult<GetV1OauthClientsCategoriesResponses, GetV1OauthClientsCategoriesErrors, ThrowOnError> => (options?.client ?? client).get<GetV1OauthClientsCategoriesResponses, GetV1OauthClientsCategoriesErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/oauthClients/categories',
    ...options
});

/**
 * Create a RequestToJoin
 *
 *  Create a RequestToJoin for an identity asking to join a public or protected BusinessPartner.  This will notify User administrators of the RequestToJoin.  The current Identity (based on the token) is the requesting Identity.  The current BusinessPartner (based on the token) must be the parent of the BusinessPartner (or the bp itself) which the Identity is requesting to join. Requires scope "topcon.ciam.pap".
 */
export const postV1RequestToJoin = <ThrowOnError extends boolean = false>(options: Options<PostV1RequestToJoinData, ThrowOnError>): RequestResult<PostV1RequestToJoinResponses, PostV1RequestToJoinErrors, ThrowOnError> => (options.client ?? client).post<PostV1RequestToJoinResponses, PostV1RequestToJoinErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/requestToJoin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a particular RequestToJoin
 *
 *  Delete a particular RequestToJoin for the current BusinessPartner (based on the token).  This is used by administrators to reject a RequestToJoin. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1RequestToJoinById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1RequestToJoinByIdData, ThrowOnError>): RequestResult<DeleteV1RequestToJoinByIdResponses, DeleteV1RequestToJoinByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1RequestToJoinByIdResponses, DeleteV1RequestToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/requestToJoin/{id}',
    ...options
});

/**
 * Get a particular RequestToJoin
 *
 *  Get a particular RequestToJoin. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1RequestToJoinById = <ThrowOnError extends boolean = false>(options: Options<GetV1RequestToJoinByIdData, ThrowOnError>): RequestResult<GetV1RequestToJoinByIdResponses, GetV1RequestToJoinByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1RequestToJoinByIdResponses, GetV1RequestToJoinByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/requestToJoin/{id}',
    ...options
});

/**
 * Get the list of RequestToJoin for the current BusinessPartner (based on the token)
 *
 *  Get the list of RequestToJoin for the current BusinessPartner.  An administrator may approve a RequestToJoin by creating a User with the same Identity id.  To reject a request, delete the RequestToJoin entity. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1RequestsToJoin = <ThrowOnError extends boolean = false>(options?: Options<GetV1RequestsToJoinData, ThrowOnError>): RequestResult<GetV1RequestsToJoinResponses, GetV1RequestsToJoinErrors, ThrowOnError> => (options?.client ?? client).get<GetV1RequestsToJoinResponses, GetV1RequestsToJoinErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/requestsToJoin',
    ...options
});

/**
 * Get the current roles (based on the token)
 *
 *  Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1RolesCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetV1RolesCurrentData, ThrowOnError>): RequestResult<GetV1RolesCurrentResponses, GetV1RolesCurrentErrors, ThrowOnError> => (options?.client ?? client).get<GetV1RolesCurrentResponses, GetV1RolesCurrentErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/roles/current',
    ...options
});

/**
 * Create a support token
 *
 *  Create a support token for Topcon customer service support. Sign-in with the email support-token@topcon.com and use a token created here to authenticate as the target identity. Must have `topcon.customer_service.support` profile. Current business partner must be type `topcon`. Must be called from the CSSD client (topcon-cssd). Requires scope "topcon.ciam.pap".
 */
export const postV1SupportToken = <ThrowOnError extends boolean = false>(options: Options<PostV1SupportTokenData, ThrowOnError>): RequestResult<PostV1SupportTokenResponses, PostV1SupportTokenErrors, ThrowOnError> => (options.client ?? client).post<PostV1SupportTokenResponses, PostV1SupportTokenErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/supportToken',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a User
 *
 *  Create a User for the current BusinessPartner.  The current identity cannot add themself, except the owner.  The create operation will succeed if the email domain of the Identity matches a registered domain for the BusinessPartner, or if there is a RequestToJoin for the identity. Any matching RequestToJoin is deleted. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1User = <ThrowOnError extends boolean = false>(options: Options<PostV1UserData, ThrowOnError>): RequestResult<PostV1UserResponses, PostV1UserErrors, ThrowOnError> => (options.client ?? client).post<PostV1UserResponses, PostV1UserErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current User
 *
 *  Get the current User.  The result will include a hydrated BusinessPartner and Identity. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1UserCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetV1UserCurrentData, ThrowOnError>): RequestResult<GetV1UserCurrentResponses, GetV1UserCurrentErrors, ThrowOnError> => (options?.client ?? client).get<GetV1UserCurrentResponses, GetV1UserCurrentErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/user/current',
    ...options
});

/**
 * Get the list of apps for the current User (based on the token)
 *
 *  Get the list of apps usable by the current user. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1UserCurrentApps = <ThrowOnError extends boolean = false>(options?: Options<GetV1UserCurrentAppsData, ThrowOnError>): RequestResult<GetV1UserCurrentAppsResponses, GetV1UserCurrentAppsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1UserCurrentAppsResponses, GetV1UserCurrentAppsErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/user/current/apps',
    ...options
});

/**
 * Get the list of apps for the current User (based on the token)
 *
 *  Deprecated: Use /v1/user/current/apps instead. Get the list of apps usable by the current user. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1UserCurrentOauthClients = <ThrowOnError extends boolean = false>(options?: Options<GetV1UserCurrentOauthClientsData, ThrowOnError>): RequestResult<GetV1UserCurrentOauthClientsResponses, GetV1UserCurrentOauthClientsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1UserCurrentOauthClientsResponses, GetV1UserCurrentOauthClientsErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/user/current/oauthClients',
    ...options
});

/**
 * Delete a particular User
 *
 *  Delete a User for the current BusinessPartner.  Any User may be deleted (as the owner is always an implied user). Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1UserById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1UserByIdData, ThrowOnError>): RequestResult<DeleteV1UserByIdResponses, DeleteV1UserByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1UserByIdResponses, DeleteV1UserByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/user/{id}',
    ...options
});

/**
 * Get a particular User
 *
 *  Get a particular User for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1UserById = <ThrowOnError extends boolean = false>(options: Options<GetV1UserByIdData, ThrowOnError>): RequestResult<GetV1UserByIdResponses, GetV1UserByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1UserByIdResponses, GetV1UserByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/user/{id}',
    ...options
});

/**
 * Update a particular User
 *
 *  Update a particular User for the current BusinessPartner.  A identity cannot update themself, except the owner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1UserById = <ThrowOnError extends boolean = false>(options: Options<PutV1UserByIdData, ThrowOnError>): RequestResult<PutV1UserByIdResponses, PutV1UserByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1UserByIdResponses, PutV1UserByIdErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/user/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of User for the current BusinessPartner (based on the token)
 *
 *  Get the Users for the current BusinessPartner.  The response will include hydrated Identity entities for each User, and an the owning identity entity for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1Users = <ThrowOnError extends boolean = false>(options?: Options<GetV1UsersData, ThrowOnError>): RequestResult<GetV1UsersResponses, GetV1UsersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1UsersResponses, GetV1UsersErrors, ThrowOnError>({
    security: [
        {
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        },
        {
            key: '2-bearer-token',
            scheme: 'bearer',
            type: 'http'
        }
    ],
    url: '/v1/users',
    ...options
});
